import ApiRequestManagerInstance from '../ApiRequestManager';
import EpgEvent from '../../classes/epgEvent';
import { store } from '@shared/store/store';
import {
  EventMap,
  IEPGEventRequest,
  IEventsRequest,
} from '../../types/interfaces/event';

const MAX_ALLOWED_TIME = 3 * 60 * 60 * 1000;

export default function eventsRequest(date: string) {
  const promise = new Promise<EventMap>(async (resolve, reject) => {
    try {
      const response: IEventsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: 'carrier',
          type: 'events',
          params: date + '.json',
        },
      })) as unknown as IEventsRequest;

      // Filter, map, sort and save events into object

      const {
        channels: { channelsData },
      } = store.getState();

      const currentDate = Date.now();

      const events: EventMap = {};
      response.data
        .filter((event) => {
          const startDate = new Date(event.beginTime || '').getTime();
          return startDate < currentDate + MAX_ALLOWED_TIME;
        })
        .filter((event) =>
          channelsData?.find((channel) => event.channel === channel.id)
        )
        .map((value: IEPGEventRequest) => {
          return new EpgEvent(value);
        })
        .sort((item1, item2) => {
          if ((item1?.date?.start || 0) > (item2?.date?.start || 0)) {
            return 1;
          }
          return -1;
        })
        .forEach((value: EpgEvent) => {
          if (!events[value.channelId]) {
            events[value.channelId] = [];
          }
          events[value.channelId].push(value);
        });

      resolve(events);
    } catch (e) {
      reject([]);
    }
  });

  return promise;
}
